"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var relay_runtime_1 = require("relay-runtime");
var useRelayEnvironment_1 = require("./useRelayEnvironment");
var FragmentResolver_1 = require("./FragmentResolver");
function useOssFragment(fragmentNode, fragmentRef) {
    relay_runtime_1.RelayFeatureFlags.PREFER_FRAGMENT_OWNER_OVER_CONTEXT = true;
    var environment = useRelayEnvironment_1.default();
    var _a = react_1.useState(null), forceUpdate = _a[1];
    var ref = react_1.useRef(null);
    if (ref.current === null || ref.current === undefined) {
        ref.current = {
            resolver: new FragmentResolver_1.default(forceUpdate),
        };
    }
    var resolver = ref.current.resolver;
    react_1.useEffect(function () {
        return function () {
            resolver.dispose();
        };
    }, []);
    resolver.resolve(environment, fragmentNode, fragmentRef);
    var data = resolver.getData();
    return [
        data,
        {
            refetch: resolver.refetch,
            loadMore: resolver.loadMore,
            hasMore: resolver.hasMore,
            isLoading: resolver.isLoading,
            refetchConnection: resolver.refetchConnection,
        },
    ];
}
exports.default = useOssFragment;
/**
 * use case?
      // Otherwise, for convenience short-circuit if all non-Relay props
      // are scalar and equal
      const keys = Object.keys(nextProps);
      for (let ii = 0; ii < keys.length; ii++) {
        const key = keys[ii];
        if (key === '__relayContext') {
          if (
            nextState.prevPropsContext.environment !==
              this.state.prevPropsContext.environment ||
            nextState.prevPropsContext.variables !==
              this.state.prevPropsContext.variables
          ) {
            return true;
          }
        } else {
          if (
            !fragments.hasOwnProperty(key) &&
            !isScalarAndEqual(nextProps[key], this.props[key])
          ) {
            return true;
          }
        }
      }
 */
